import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Capability } from "../../common/_types/capability";
import { Transaction } from "sip.js/lib/core";
import { TransactionSerie } from "../../transactions-series/_types/transaction-serie";

export class ContractTransactionSerie extends Resource {
    public override type = 'contractTransactionSeries';
    
    @prop()
    public contractId!: string;
    @prop()
    @required()
    public transactionSerieId!: string;

    @propObject()
    public transactionSerie!: TransactionSerie;
}